<template>
    <template v-if="step === 1">
        <div class="text-h4 font-weight-bold mb-1">
            {{ $t('referrers.Leave your details to get your quote') }}
        </div>
        <div class="text-body-1 mt-3">{{ $t('referrers.We will contact you for your personal offer') }}</div>
        <v-form @submit.prevent="(e) => nextStep(e,true)">
            <input role="presentation" autocomplete="off" style="display: none"/>
            <v-row no-gutters class="pt-8">
                <v-col cols="6" :class="$vuetify.display.mdAndUp?'pr-6':'pr-4'">
                    <div class="text-body-1 font-weight-bold mb-2">{{ $t('referrers.First name') }}</div>
                    <v-text-field v-model="form.first_name" flat variant="solo"
                                  :placeholder="$t('referrers.placeholers-first_name')"
                                  :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" :class="$vuetify.display.mdAndUp?'pl-6':'pl-4'">
                    <div class="text-body-1 font-weight-bold mb-2">{{ $t('referrers.Last name') }}</div>
                    <v-text-field v-model="form.last_name" flat variant="solo"
                                  :placeholder="$t('referrers.placeholers-last_name')"
                                  :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6" :class="$vuetify.display.mdAndUp?'pr-6':''">
                    <div class="text-body-1 font-weight-bold mb-2">{{ $t('referrers.Email') }}</div>
                    <v-text-field v-model="form.email" flat variant="solo"
                                  :placeholder="$t('referrers.placeholers-email')"
                                  :rules="[rules.required, rules.email]"
                                  :error-messages="errors.email ? [errors.email[0]] : []"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6" :class="$vuetify.display.mdAndUp?'pl-6':''">
                    <div class="text-body-1 font-weight-bold mb-2">{{ $t('referrers.Phone') }}</div>
                    <v-text-field v-model="form.phone" flat variant="solo" :mask="'####-###-###'"
                                  :placeholder="$t('referrers.placeholers-phone')"
                                  :rules="[rules.required,rules.phone]"></v-text-field>
                </v-col>
                <v-col cols="12">
                    <div class="text-body-1 font-weight-bold mb-2">{{ $t('referrers.Address') }}</div>
                    <v-text-field v-model="form.address" flat variant="solo"
                                  :placeholder="$t('referrers.Address_placeholder')"
                                  :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-btn color="success" size="large" append-icon="mdi-arrow-right" block
                           class="py-6 font-weight-bold text-capitalize" type="submit">{{ $t('referrers.Send') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </template>
    <template v-if="step === 2">
        <div class="text-h4 font-weight-bold mb-1">
            {{ $t('referrers.You are all set') }}
        </div>
        <div class="text-body-1">{{ $t('referrers.We will contact you for your personal offer') }}</div>
        <v-row class="my-16">
            <v-col cols="12">
                <div class="d-flex justify-center align-center">
                    <v-icon icon="mdi-check-circle" size="100" color="success"></v-icon>
                    <div class="text-body-1">{{ $t('referrers.We will be in touch soon') }}</div>
                </div>
            </v-col>
        </v-row>
    </template>
</template>

<script>
export default {
    name: "FormStepperSimple",
    props: {
        errors: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            step: 1,
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                address: '',
            },
            rules: {
                required: value => !!value || this.$t('referrers.Field is required'),
                email: value => !value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) || this.$t('referrers.E-mail must be valid'),
                // phone: value => !value || /^0\d{8,10}$/.test(value) || 'Phone must be valid'
            },
        }
    },
    methods: {
        async nextStep(e, confirm = false) {
            e.preventDefault();
            e.stopPropagation();
            let res = await e;
            if (!res.valid) return;
            if (confirm) {
                this.$inertia.post(this.route("referral.friend-lead"), this.form, {
                    onSuccess: () => this.step += 1,
                    preserveScroll: true,
                });
            }
            // this.step += 1;
        }
    },
}
</script>

<style>
.opacity-1 {
    opacity: 1;
}

.v-radio.opacity-1 .v-label {
    opacity: 1;
}

.text-color-address {
    color: rgba(20, 20, 48, 0.5);
}
</style>
